import {
  formatPercentageValue,
  formatValueWithMiddlewares,
  checkForNA,
  appendPercentage,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const {
      productionPlanningAccomplishment,
      productionPlanningAccomplishmentPercentageDelta,
    } = data;

    return createKpiTileItem(
      'Production Planning Accomplishment (CPP)',
      formatPercentageValue(productionPlanningAccomplishment),
      productionPlanningAccomplishmentPercentageDelta
        ? {
            isPositiveValue:
              productionPlanningAccomplishmentPercentageDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(productionPlanningAccomplishmentPercentageDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: productionPlanningAccomplishmentPercentageDelta !== 0,
          }
        : []
    );
  },
};
